import { render, staticRenderFns } from "./course-video-view.vue?vue&type=template&id=393c5703&scoped=true&"
import script from "./course-video-view.vue?vue&type=script&lang=js&"
export * from "./course-video-view.vue?vue&type=script&lang=js&"
import style0 from "./course-video-view.vue?vue&type=style&index=0&id=393c5703&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393c5703",
  null
  
)

export default component.exports